module.exports = __webpack_public_path__ + "img/goods14_1.2f9c599c.jpg";